export default __webpack_public_path__ + "files/b2ddd5a31109fdc16c032178055f4016.png";